class Track {
    constructor(options = {}){
        this.options = Object.assign(
            {},
            {    
                clientId: "6167f4bd3d884803dedbd2df", 
                gtmID: "GTM-T2GP2KW",  
                envWork : 'production', 
                language : 'fr',
                userAuthenticated : '0',
                userId : '',
                pageName : '',
                pageCategory : ''  
            }, 
            options
        );   

        window.dataLayer = window.dataLayer || []; 
        window.gtag = function(){dataLayer.push(arguments)}; 

        window.axeptioSettings = {
            clientId: this.options.clientId,
            cookiesVersion: this.options.cookiesVersion,
            googleConsentMode: {
                default: {
                    analytics_storage: 'denied',
                    ad_storage: 'denied',
                    ad_user_data: 'denied', 
                    ad_personalization: 'denied',
                    wait_for_update: 500 
                } 
            }
        }; 

        window.gtag('consent', 'default', {
            analytics_storage: 'denied',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            wait_for_update: 500  
        });   
  
 
        window.Shopify.loadFeatures([
            {
            name: "consent-tracking-api",
            version: "0.1",
            }],
            error => {
                if (error) {
                  // Rescue error
                }
                this.initRgpd();
            } 
        );  
 
        
    }
 
 
    loadGTM(id, checkout = false){ 
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start":
        new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:"";j.async=true;j.src=
        "https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,"script","dataLayer",id);   
        if(this.objInit != "" && typeof this.objInit != "undefined" && typeof this.objInit == "object"){
            this.push(this.objInit);  
        }
    } 

    push(obj){ 
        var dataInit = {
            'EnvWork' : this.options.envWork, 
            'Language' : this.options.language, 
            'UserAuthenticated' : this.options.userAuthenticated, 
            'UserId' : this.options.userId, 
            'PageName' : this.options.pageName, 
            'PageCategory' : this.options.pageCategory
        };
        var dataMerge = {...dataInit, ...obj}; 
        console.log(dataMerge);
        window.dataLayer.push(dataMerge); 
    }

    initRgpd() {   
        window.Shopify.customerPrivacy.setTrackingConsent(
            {
                preferences: true,
                analytics: true,
                marketing: true,
                sale_of_data: true
            }, 
            () => {}
        ); 
        this.loadGTM(this.options.gtmID);       
 
    }  

    deleteCookie(name){ 
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }  
    
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    
    setCookie(name,value,days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
}